/* MoRetro Studio V21.0 — Paramètres Atelier
   Stockage Firestore : settings/moretro_studio
   Sert de base pour les imprimantes, filaments et réglages devis.
*/
window.MTS = window.MTS || {};

(function(MTS){
  "use strict";

  const THEME_KEY = "moretroStudioThemeV27";
  const THEME_VALUES = ["dark", "light", "system"];

  function normalizedTheme(value){
    return THEME_VALUES.includes(value) ? value : "dark";
  }

  function savedTheme(){
    try{ return normalizedTheme(localStorage.getItem(THEME_KEY) || "dark"); }
    catch(e){ return "dark"; }
  }

  function applyTheme(value, persist = true){
    const selected = normalizedTheme(value);
    const resolved = selected === "system"
      ? (window.matchMedia?.("(prefers-color-scheme: light)")?.matches ? "light" : "dark")
      : selected;

    document.documentElement.dataset.mtsTheme = resolved;
    document.documentElement.dataset.mtsThemeChoice = selected;
    document.documentElement.style.colorScheme = resolved;

    if(persist){
      try{ localStorage.setItem(THEME_KEY, selected); }catch(e){}
    }

    document.querySelectorAll("[data-mts-theme-choice]").forEach(button=>{
      const active = button.dataset.mtsThemeChoice === selected;
      button.classList.toggle("active", active);
      button.setAttribute("aria-pressed", active ? "true" : "false");
    });
  }

  applyTheme(savedTheme(), false);
  window.matchMedia?.("(prefers-color-scheme: light)")?.addEventListener?.("change", ()=>{
    if(savedTheme() === "system") applyTheme("system", false);
  });

  const DEFAULT_SETTINGS = {
    appearance:{
      theme:"dark"
    },
    shop:{
      name:"MoRetro 3D",
      senderEmail:"contact@moretro3d.fr"
    },
    printers:[
      {id:"ender1", name:"Ender 3 V3 SE #1", active:true},
      {id:"ender2", name:"Ender 3 V3 SE #2", active:true},
      {id:"sidewinder", name:"Sidewinder X4 Plus", active:true},
      {id:"kobra", name:"Kobra S1", active:true},
      {id:"p2s1", name:"P2S #1", active:true},
      {id:"p2s2", name:"P2S #2", active:true},
      {id:"h2d", name:"H2D", active:true}
    ],
    filaments:[
      {id:"pla-noir", name:"PLA Noir", material:"PLA", color:"Noir", brand:"Générique", newWeightG:1000, remainingG:1000, purchasePrice:23, kgPrice:23, diameter:"1.75", nozzleTemp:220, bedTemp:60, supplier:"", reference:"", notes:"", active:true, compatiblePrinters:[]},
      {id:"pla-blanc", name:"PLA Blanc", material:"PLA", color:"Blanc", brand:"Générique", newWeightG:1000, remainingG:1000, purchasePrice:23, kgPrice:23, diameter:"1.75", nozzleTemp:220, bedTemp:60, supplier:"", reference:"", notes:"", active:true, compatiblePrinters:[]},
      {id:"petg-noir", name:"PETG Noir", material:"PETG", color:"Noir", brand:"Générique", type:"filament", newWeightG:1000, remainingG:1000, purchasePrice:28, kgPrice:28, diameter:"1.75", nozzleTemp:250, bedTemp:90, supplier:"", reference:"", notes:"", active:true, compatiblePrinters:[]},
      {id:"resine-standard", name:"Résine Standard", material:"RESINE", color:"Gris", brand:"Générique", type:"resin", newVolumeL:1, remainingVolumeL:1, purchasePrice:28, literPrice:28, supplier:"", reference:"", notes:"", active:true, compatiblePrinters:[]}
    ],
    quoteDefaults:{
      material:"PLA",
      filamentKgPrice:23,
      electricityHourly:0.25,
      laborFixed:10,
      marginPercent:30
    },
    mails:{
      automatic:true
    },
    shipping:{
      carriers:["Colissimo","Chronopost","Mondial Relay"]
    },
    library:{
      filamentBrands:[],
      resinBrands:[],
      filamentMaterials:[],
      resinMaterials:[],
      colors:[],
      printerBrands:[],
      printerModels:[]
    }
  };


  const FILAMENT_BRANDS = [
    "3DXTech","AzureFilm","Bambu Lab","BASF","ColorFabb","Copper3D","Creality","Elegoo","eSun","Extrudr",
    "Fiberon by Polymaker","FormFutura","Innovatefil","Jamg He","Kimya","Landu","Lattice Medical",
    "Mitsubishi Chemical","Nanovia FR","Owa","Panchroma by Polymaker","Polymaker","ProtoPasta","Prusa",
    "R3D","Raise3D","Recreus","Rosa3D","Smart Materials 3D","Sunlu","Tag3D FR","TigerTag","Verbatim",
    "XStrand FR","Zmorph","Zortrax","Autre..."
  ];

  const RESIN_BRANDS = [
    "ALT Resins","Antinsky","Anycubic","ApexMaker","BASF","BlueCast","Creality","Detax","Elegoo Resin",
    "eSun Resin","FunToDo","Jamg He","Liqcreate","Loctite","Monocure3D","Monocure Dental","Phrozen",
    "Poc Lab","Sunlu","UniFormation","Zortrax","Autre..."
  ];

  const FILAMENT_MATERIALS = [
    "PLA","PLA+","PETG","ABS","ASA","TPU","PC","PA","PA-CF","PETG-CF","PLA-CF","HIPS","PVA","Bois","Autre..."
  ];

  const RESIN_MATERIALS = [
    "Résine Standard","Résine ABS-like","Résine Tough","Résine Flexible","Résine Haute Température",
    "Résine Water Washable","Résine Dental","Résine Castable","Résine ESD-safe","Autre..."
  ];

  const MATERIAL_COLORS = [
    "Noir","Blanc","Gris","Rouge","Bleu","Vert","Jaune","Orange","Violet","Rose","Marron","Transparent",
    "Naturel","Bois","Or","Argent","Cuivre","Multicolore","Autre..."
  ];

  function uniqueList(list){
    return [...new Set((list || []).map(v=>String(v || "").trim()).filter(Boolean))];
  }

  function libraryList(key, baseList){
    const custom = MTS.state.settings?.library?.[key] || [];
    const withoutOther = (baseList || []).filter(v=>v !== "Autre...");
    return [...uniqueList([...withoutOther, ...custom]).sort((a,b)=>a.localeCompare(b, "fr")), "Autre..."];
  }

  function selectOptions(list, selected = ""){
    const value = String(selected || "");
    const has = list.includes(value);
    const finalList = has || !value ? list : [value, ...list];
    return finalList.map(item=>`<option value="${MTS.escapeHtml(item)}" ${item===value?"selected":""}>${MTS.escapeHtml(item)}</option>`).join("");
  }

  function brandOptions(f = {}){
    return selectOptions(isResin(f) ? libraryList("resinBrands", RESIN_BRANDS) : libraryList("filamentBrands", FILAMENT_BRANDS), f.brand || "");
  }

  function materialOptionsForItem(f = {}){
    return selectOptions(isResin(f) ? libraryList("resinMaterials", RESIN_MATERIALS) : libraryList("filamentMaterials", FILAMENT_MATERIALS), f.material || "");
  }

  function colorOptions(selected = ""){
    return selectOptions(libraryList("colors", MATERIAL_COLORS), selected || "");
  }



  const LOCAL_SETTINGS_KEY = "moretroStudioSettingsV21";

  function loadLocalSettings(){
    try{
      const raw = localStorage.getItem(LOCAL_SETTINGS_KEY);
      return raw ? JSON.parse(raw) : null;
    }catch(e){
      return null;
    }
  }

  function saveLocalSettings(settings){
    try{
      localStorage.setItem(LOCAL_SETTINGS_KEY, JSON.stringify(settings));
      return true;
    }catch(e){
      console.warn("Sauvegarde locale impossible :", e.message);
      return false;
    }
  }


  function clone(value){
    return JSON.parse(JSON.stringify(value));
  }

  function uid(prefix){
    return `${prefix}-${Date.now()}-${Math.random().toString(16).slice(2)}`;
  }

  function mergeSettings(data){
    return {
      ...clone(DEFAULT_SETTINGS),
      ...(data || {}),
      appearance:{...DEFAULT_SETTINGS.appearance, ...(data?.appearance || {})},
      shop:{...DEFAULT_SETTINGS.shop, ...(data?.shop || {})},
      quoteDefaults:{...DEFAULT_SETTINGS.quoteDefaults, ...(data?.quoteDefaults || {})},
      mails:{...DEFAULT_SETTINGS.mails, ...(data?.mails || {})},
      shipping:{...DEFAULT_SETTINGS.shipping, ...(data?.shipping || {})},
      library:{
        filamentBrands:Array.isArray(data?.library?.filamentBrands) ? data.library.filamentBrands : [],
        resinBrands:Array.isArray(data?.library?.resinBrands) ? data.library.resinBrands : [],
        filamentMaterials:Array.isArray(data?.library?.filamentMaterials) ? data.library.filamentMaterials : [],
        resinMaterials:Array.isArray(data?.library?.resinMaterials) ? data.library.resinMaterials : [],
        colors:Array.isArray(data?.library?.colors) ? data.library.colors : [],
        printerBrands:Array.isArray(data?.library?.printerBrands) ? data.library.printerBrands : [],
        printerModels:Array.isArray(data?.library?.printerModels) ? data.library.printerModels : []
      },
      printers:Array.isArray(data?.printers) ? data.printers : clone(DEFAULT_SETTINGS.printers),
      filaments:Array.isArray(data?.filaments) ? data.filaments : clone(DEFAULT_SETTINGS.filaments)
    };
  }

  function ref(){
    if(!MTS.state?.db) return null;
    return MTS.state.db.collection("settings").doc("moretro_studio");
  }

  async function load(){
    const local = loadLocalSettings();

    const r = ref();
    if(!r){
      MTS.state.settings = mergeSettings(local);
      return MTS.state.settings;
    }

    try{
      const snap = await r.get();

      if(!snap.exists){
        MTS.state.settings = mergeSettings(local);
        try{
          await r.set(MTS.state.settings, {merge:true});
        }catch(err){
          console.warn("Paramètres Firestore non accessibles, utilisation locale :", err.message);
          saveLocalSettings(MTS.state.settings);
        }
        return MTS.state.settings;
      }

      MTS.state.settings = mergeSettings(snap.data());
      saveLocalSettings(MTS.state.settings);
      return MTS.state.settings;
    }catch(err){
      console.warn("Lecture paramètres Firestore refusée, utilisation locale :", err.message);
      MTS.state.settings = mergeSettings(local);
      return MTS.state.settings;
    }
  }

  async function save(settings){
    const next = mergeSettings(settings);
    MTS.state.settings = next;

    // Sauvegarde locale systématique pour éviter toute perte si Firestore refuse.
    saveLocalSettings(next);

    const r = ref();
    if(r){
      try{
        await r.set({
          ...next,
          updatedAt:firebase.firestore.FieldValue.serverTimestamp()
        }, {merge:true});
      }catch(err){
        console.warn("Paramètres sauvegardés en local uniquement :", err.message);
      }
    }

    render(openedSettingSections());
    return next;
  }

  function activePrinters(){
    const s = MTS.state.settings || mergeSettings(null);
    return (s.printers || []).filter(p=>p.active !== false);
  }

  function activeFilaments(){
    const s = MTS.state.settings || mergeSettings(null);
    return (s.filaments || []).filter(f=>f.active !== false);
  }

  function printerOptions(selected = ""){
    return activePrinters().map(p=>`<option value="${MTS.escapeHtml(p.name)}" ${p.name===selected?"selected":""}>${MTS.escapeHtml(p.name)}</option>`).join("");
  }

  function materialOptions(selected = ""){
    const values = [...new Set(activeFilaments().map(f=>f.material).filter(Boolean))];
    const fallback = ["PLA","PETG","ABS","ASA","TPU","RESINE"];
    const all = values.length ? values : fallback;
    return all.map(v=>`<option value="${MTS.escapeHtml(v)}" ${v===selected?"selected":""}>${MTS.escapeHtml(v)}</option>`).join("");
  }

  function kgPriceFor(material){
    const found = activeFilaments().find(f=>String(f.material).toLowerCase() === String(material).toLowerCase() && (Number(f.kgPrice)>0 || Number(f.literPrice)>0));
    return Number(found?.kgPrice || found?.literPrice || MTS.state.settings?.quoteDefaults?.filamentKgPrice || 23);
  }

  function filamentOptions(selected = ""){
    return activeFilaments().map(f=>{
      const stock = isResin(f)
        ? `${Number(f.remainingVolumeL || 0).toFixed(2).replace(".", ",")} L`
        : `${Number(f.remainingG || 0)} g`;
      const label = `${filamentLabel(f)} (${stock})`;
      const value = f.id || filamentLabel(f);
      return `<option value="${MTS.escapeHtml(value)}" ${value===selected?"selected":""}>${MTS.escapeHtml(label)}</option>`;
    }).join("");
  }

  function filamentById(id){
    return activeFilaments().find(f => String(f.id) === String(id)) || null;
  }

  function renderPrinterRow(p, i){
    return `
      <div class="mts-setting-row">
        <input data-setting-printer-index="${i}" data-field="name" value="${MTS.escapeHtml(p.name || "")}" placeholder="Nom imprimante">
        <label class="mts-setting-check"><input type="checkbox" data-setting-printer-index="${i}" data-field="active" ${p.active!==false?"checked":""}> Active</label>
        <button type="button" class="mts-btn mts-danger" data-remove-printer="${i}">Supprimer</button>
      </div>
    `;
  }

  function filamentLabel(f = {}){
    return f.name || [f.brand, f.material, f.color].filter(Boolean).join(" ") || "Bobine filament";
  }

  function filamentPercent(f = {}){
    if(isResin(f)){
      const totalL = Number(f.newVolumeL || 0);
      const restL = Number(f.remainingVolumeL || 0);
      if(!totalL) return 0;
      return Math.max(0, Math.min(100, Math.round((restL / totalL) * 100)));
    }

    const total = Number(f.newWeightG || 0);
    const rest = Number(f.remainingG || 0);
    if(!total) return 0;
    return Math.max(0, Math.min(100, Math.round((rest / total) * 100)));
  }

  function isResin(f = {}){
    const mat = String(f.material || "").toLowerCase();
    return f.type === "resin" || mat.includes("resine") || mat.includes("résine") || mat.includes("resin");
  }

  function filamentStatus(f = {}){
    if(isResin(f)){
      const rest = Number(f.remainingVolumeL || 0);
      if(rest <= 0.10) return {label:"🔴 Remplacer", cls:"danger"};
      if(rest <= 0.20) return {label:"🟠 Stock faible", cls:"warn"};
      return {label:"🟢 OK", cls:"ok"};
    }

    const rest = Number(f.remainingG || 0);
    if(rest <= 100) return {label:"🔴 Remplacer", cls:"danger"};
    if(rest <= 200) return {label:"🟠 Stock faible", cls:"warn"};
    return {label:"🟢 OK", cls:"ok"};
  }

  function compatiblePrinterOptions(f = {}){
    const selected = Array.isArray(f.compatiblePrinters) ? f.compatiblePrinters : [];
    const printers = MTS.state.settings?.printers || [];
    if(!printers.length) return `<span class="mts-muted">Aucune imprimante configurée.</span>`;

    return printers.map(p=>`
      <label class="mts-setting-check">
        <input type="checkbox" data-setting-filament-index="${f.__index}" data-field="compatiblePrinters" value="${MTS.escapeHtml(p.name)}" ${selected.includes(p.name) ? "checked" : ""}>
        ${MTS.escapeHtml(p.name)}
      </label>
    `).join("");
  }

  function renderFilamentRow(raw, i){
    const f = {...raw, __index:i};
    const pct = filamentPercent(f);
    const status = filamentStatus(f);
    const resin = isResin(f);
    const remaining = resin ? Number(f.remainingVolumeL || 0) : Number(f.remainingG || 0);
    const total = resin ? Number(f.newVolumeL || 0) : Number(f.newWeightG || 0);
    const price = Number(f.purchasePrice || 0);
    const unitPrice = resin ? Number(f.literPrice || 0) : Number(f.kgPrice || 0);
    const stockLabel = resin
      ? `${remaining.toFixed(2).replace(".", ",")} L / ${total || "?"} L`
      : `${remaining} g / ${total || "?"} g`;

    return `
      <article class="mts-filament-card">
        <div class="mts-filament-head">
          <div>
            <strong>🧵 ${MTS.escapeHtml(filamentLabel(f))}</strong>
            <span>${MTS.escapeHtml(f.material || "Matière")} • ${MTS.escapeHtml(f.color || "Couleur")} • ${MTS.escapeHtml(f.brand || "Marque")}</span>
          </div>
          <em class="mts-filament-status ${status.cls}">${status.label}</em>
        </div>

        <div class="mts-filament-bar">
          <i style="width:${pct}%"></i>
        </div>
        <div class="mts-filament-meta">
          <span>${stockLabel}</span>
          <span>${pct}%</span>
        </div>

        <details class="mts-filament-edit">
          <summary>Modifier la bobine</summary>

          <div class="mts-setting-grid">
            <label>Nom<input data-setting-filament-index="${i}" data-field="name" value="${MTS.escapeHtml(f.name || "")}" placeholder="Sunlu PLA Noir"></label>
            <label>Type<select data-setting-filament-index="${i}" data-field="type" data-filament-type-select>
              <option value="filament" ${!resin ? "selected" : ""}>Filament</option>
              <option value="resin" ${resin ? "selected" : ""}>Résine</option>
            </select></label>
            <label>Marque<select data-setting-filament-index="${i}" data-field="brand" data-brand-select>${brandOptions(f)}</select></label>
            <label class="${f.brand==="Autre..." ? "" : "mts-setting-hidden"}" data-custom-brand-wrap="${i}">Marque personnalisée<input data-setting-filament-index="${i}" data-field="customBrand" value="${MTS.escapeHtml(f.customBrand || "")}" placeholder="Nom de la marque"></label>
            <label>Matière<select data-setting-filament-index="${i}" data-field="material">${materialOptionsForItem(f)}</select></label>
            <label class="${f.material==="Autre..." ? "" : "mts-setting-hidden"}" data-custom-material-wrap="${i}">Matière personnalisée<input data-setting-filament-index="${i}" data-field="customMaterial" value="${MTS.escapeHtml(f.customMaterial || "")}" placeholder="Nom de la matière"></label>
            <label>Couleur<select data-setting-filament-index="${i}" data-field="color">${colorOptions(f.color || "")}</select></label>
            <label class="${f.color==="Autre..." ? "" : "mts-setting-hidden"}" data-custom-color-wrap="${i}">Couleur personnalisée<input data-setting-filament-index="${i}" data-field="customColor" value="${MTS.escapeHtml(f.customColor || "")}" placeholder="Nom de la couleur"></label>

            ${resin ? `
              <label>Volume neuf L<input type="number" step="0.01" min="0" data-setting-filament-index="${i}" data-field="newVolumeL" value="${MTS.escapeHtml(f.newVolumeL || 1)}"></label>
              <label>Volume restant L<input type="number" step="0.01" min="0" data-setting-filament-index="${i}" data-field="remainingVolumeL" value="${MTS.escapeHtml(f.remainingVolumeL || 0)}"></label>
              <label>Prix achat €<input type="number" step="0.01" min="0" data-setting-filament-index="${i}" data-field="purchasePrice" value="${MTS.escapeHtml(price || "")}"></label>
              <label>Prix au litre €<input type="number" step="0.01" min="0" data-setting-filament-index="${i}" data-field="literPrice" value="${MTS.escapeHtml(unitPrice || "")}"></label>
            ` : `
              <label>Poids neuf g<input type="number" step="1" min="0" data-setting-filament-index="${i}" data-field="newWeightG" value="${MTS.escapeHtml(f.newWeightG || 1000)}"></label>
              <label>Poids restant g<input type="number" step="1" min="0" data-setting-filament-index="${i}" data-field="remainingG" value="${MTS.escapeHtml(f.remainingG || 0)}"></label>
              <label>Prix achat €<input type="number" step="0.01" min="0" data-setting-filament-index="${i}" data-field="purchasePrice" value="${MTS.escapeHtml(price || "")}"></label>
              <label>Prix au kg €<input type="number" step="0.01" min="0" data-setting-filament-index="${i}" data-field="kgPrice" value="${MTS.escapeHtml(unitPrice || "")}"></label>
              <label>Diamètre mm<input data-setting-filament-index="${i}" data-field="diameter" value="${MTS.escapeHtml(f.diameter || "1.75")}"></label>
              <label>Buse °C<input type="number" step="1" min="0" data-setting-filament-index="${i}" data-field="nozzleTemp" value="${MTS.escapeHtml(f.nozzleTemp || "")}"></label>
              <label>Plateau °C<input type="number" step="1" min="0" data-setting-filament-index="${i}" data-field="bedTemp" value="${MTS.escapeHtml(f.bedTemp || "")}"></label>
            `}

            <label>Fournisseur<input data-setting-filament-index="${i}" data-field="supplier" value="${MTS.escapeHtml(f.supplier || "")}" placeholder="Amazon, Grossiste..."></label>

            <label>Référence<input data-setting-filament-index="${i}" data-field="reference" value="${MTS.escapeHtml(f.reference || "")}" placeholder="SUN-PLA-BLK"></label>
            <label class="mts-setting-check mts-setting-check-big"><input type="checkbox" data-setting-filament-index="${i}" data-field="active" ${f.active!==false?"checked":""}> Bobine active</label>
          </div>

          <label class="mts-setting-full">Notes
            <textarea data-setting-filament-index="${i}" data-field="notes" placeholder="Usage, réglages, remarques...">${MTS.escapeHtml(f.notes || "")}</textarea>
          </label>

          <div class="mts-compatible-box">
            <strong>🖨️ Compatible imprimantes</strong>
            <div class="mts-compatible-grid">${compatiblePrinterOptions(f)}</div>
          </div>

          <div class="mts-actions mts-material-actions">
            <button type="button" class="mts-btn mts-ok" data-validate-filament="${i}">
              ${resin ? "✅ Valider la résine" : "✅ Valider la bobine"}
            </button>
            <button type="button" class="mts-btn mts-danger" data-remove-filament="${i}">Supprimer ${resin ? "la résine" : "la bobine"}</button>
          </div>
        </details>
      </article>
    `;
  }



  const PRINTER_LIBRARY_BRANDS = ["AnkerMake", "Anycubic", "Artillery", "BCN3D", "Bambu Lab", "Biqu", "Comgrow", "Creality", "Elegoo", "FLSUN", "Flashforge", "Formlabs", "Geeetech", "Kingroon", "Longer", "LulzBot", "Markforged", "Mingda", "Modix", "Peopoly", "Phrozen", "Prusa", "QIDI Tech", "Raise3D", "RatRig", "Snapmaker", "Sovol", "Tronxy", "Ultimaker", "Uniformation", "Voron Design", "Zortrax"];
  const PRINTER_LIBRARY_MODELS = ["AnkerMake — M5", "AnkerMake — M5C", "Anycubic — Kobra 2 Max", "Anycubic — Kobra 2 Neo", "Anycubic — Kobra 2 Plus", "Anycubic — Kobra 2 Pro", "Anycubic — Kobra 3", "Anycubic — Kobra 3 Combo", "Anycubic — Kobra 3 Max Combo", "Anycubic — Kobra 4 Combo", "Anycubic — Kobra S1", "Anycubic — Kobra S1 ACE 2 Pro Combo", "Anycubic — Kobra S1 Combo", "Anycubic — Kobra S1 Max Combo", "Anycubic — Photon M3 Max", "Anycubic — Photon Mono 2", "Anycubic — Photon Mono 4", "Anycubic — Photon Mono M5s", "Anycubic — Photon Mono M7 Max", "Anycubic — Photon Mono M7 Pro", "Anycubic — Photon Mono X2", "Anycubic — Photon P1", "Artillery — Genius Pro", "Artillery — Sidewinder X2", "Artillery — Sidewinder X3 Pro", "Artillery — Sidewinder X4 Plus", "Artillery — Sidewinder X4 Plus S1", "Artillery — Sidewinder X4 Pro", "BCN3D — Epsilon W27", "BCN3D — Epsilon W50", "BCN3D — Omega I60", "BCN3D — Sigma D25", "Bambu Lab — A1", "Bambu Lab — A1 Mini", "Bambu Lab — H2C", "Bambu Lab — H2D", "Bambu Lab — H2S", "Bambu Lab — P1P", "Bambu Lab — P1S", "Bambu Lab — P2S", "Bambu Lab — X1 Carbon", "Bambu Lab — X1E", "Bambu Lab — X2D", "Biqu — BX", "Biqu — Hurakan", "Biqu — Panda P1P", "Biqu — Panda P1S", "Comgrow — T300", "Comgrow — T500", "Creality — CR-10 SE", "Creality — CR-10 Smart Pro", "Creality — CR-M4", "Creality — Ender 3", "Creality — Ender 3 S1", "Creality — Ender 3 S1 Pro", "Creality — Ender 3 V2", "Creality — Ender 3 V2 Neo", "Creality — Ender 3 V3", "Creality — Ender 3 V3 KE", "Creality — Ender 3 V3 SE", "Creality — Ender 5 Plus", "Creality — Ender 5 S1", "Creality — HALOT Mage", "Creality — HALOT Mage S", "Creality — HALOT One", "Creality — Hi", "Creality — Hi Combo", "Creality — K1", "Creality — K1 Max", "Creality — K1C", "Creality — K2 Plus", "Creality — K2 Pro", "Elegoo — Centauri Carbon", "Elegoo — Jupiter SE", "Elegoo — Mars 4", "Elegoo — Mars 5", "Elegoo — Mars 5 Ultra", "Elegoo — Neptune 3 Pro", "Elegoo — Neptune 4", "Elegoo — Neptune 4 Max", "Elegoo — Neptune 4 Plus", "Elegoo — Neptune 4 Pro", "Elegoo — Saturn 3 Ultra", "Elegoo — Saturn 4", "Elegoo — Saturn 4 Ultra", "FLSUN — QQ-S Pro", "FLSUN — S1", "FLSUN — Super Racer", "FLSUN — T1", "FLSUN — T1 Pro", "FLSUN — V400", "Flashforge — Adventurer 4", "Flashforge — Adventurer 5M", "Flashforge — Adventurer 5M Pro", "Flashforge — Creator 4", "Flashforge — Creator Pro 2", "Flashforge — Guider 3", "Flashforge — Guider 3 Ultra", "Formlabs — Form 3+", "Formlabs — Form 3L", "Formlabs — Form 4", "Formlabs — Form 4L", "Geeetech — A10M", "Geeetech — A20M", "Geeetech — A30T", "Geeetech — Mizar S", "Kingroon — KLP1", "Kingroon — KP3S", "Kingroon — KP3S Pro", "Kingroon — KP5L", "Longer — LK4 X", "Longer — LK5 Pro", "Longer — Orange 30", "Longer — Orange 4K", "LulzBot — Mini 2", "LulzBot — TAZ Pro", "LulzBot — TAZ Pro S", "LulzBot — TAZ Workhorse", "Markforged — FX10", "Markforged — Mark Two", "Markforged — Onyx One", "Markforged — Onyx Pro", "Markforged — X7", "Mingda — MD-600D", "Mingda — Magician Max", "Mingda — Magician Pro", "Mingda — Magician X", "Modix — BIG-120X", "Modix — BIG-180X", "Modix — BIG-60", "Modix — BIG-Meter", "Peopoly — Magneto X", "Peopoly — Phenom Forge", "Peopoly — Phenom Prime", "Peopoly — Phenom XXL", "Phrozen — Sonic Mega 8K", "Phrozen — Sonic Mega 8K S", "Phrozen — Sonic Mighty 8K", "Phrozen — Sonic Mighty Revo", "Phrozen — Sonic Mini 8K", "Prusa — CORE One", "Prusa — CORE One+", "Prusa — MINI+", "Prusa — MK3S+", "Prusa — MK4", "Prusa — MK4S", "Prusa — SL1S Speed", "Prusa — XL 2-Tool", "Prusa — XL 5-Tool", "Prusa — XL Single Tool", "QIDI Tech — Plus4", "QIDI Tech — Q1 Pro", "QIDI Tech — Q2", "QIDI Tech — X-CF Pro", "QIDI Tech — X-Max 3", "QIDI Tech — X-Plus 3", "Raise3D — E2", "Raise3D — E2CF", "Raise3D — Pro3", "Raise3D — Pro3 Plus", "Raise3D — RMF500", "RatRig — V-Core 3.1", "RatRig — V-Core 4 300", "RatRig — V-Core 4 400", "RatRig — V-Core 4 500", "Snapmaker — A250T", "Snapmaker — A350T", "Snapmaker — Artisan", "Snapmaker — J1", "Snapmaker — U1", "Sovol — SV04 IDEX", "Sovol — SV06", "Sovol — SV06 Plus", "Sovol — SV07", "Sovol — SV07 Plus", "Sovol — SV08", "Sovol — SV08 Max", "Tronxy — Moore 2 Pro", "Tronxy — VEHO 600", "Tronxy — X5SA", "Tronxy — X5SA Pro", "Tronxy — X5SA-400", "Ultimaker — Factor 4", "Ultimaker — S3", "Ultimaker — S5", "Ultimaker — S7", "Uniformation — GK3 Ultra", "Uniformation — GKTwo", "Voron Design — Voron 0.2", "Voron Design — Voron 2.4", "Voron Design — Voron Legacy", "Voron Design — Voron Switchwire", "Voron Design — Voron Trident", "Zortrax — Endureal", "Zortrax — Inkspire 2", "Zortrax — M200 Plus", "Zortrax — M300 Plus"];

  function renderLibraryList(title, key, baseList, placeholder){
    const s = MTS.state.settings || mergeSettings(null);
    const custom = uniqueList(s.library?.[key] || []);
    const all = uniqueList([...(baseList || []).filter(v=>v !== "Autre..."), ...custom])
      .sort((a,b)=>a.localeCompare(b, "fr"));

    return `
      <div class="mts-library-v24-box">
        <h5>${title}</h5>

        <div class="mts-library-v24-tags">
          ${all.map(v=>`<span>${MTS.escapeHtml(v)}</span>`).join("")}
        </div>

        <div class="mts-library-v24-add">
          <input data-library-add-input="${MTS.escapeHtml(key)}" placeholder="${MTS.escapeHtml(placeholder)}">
          <button type="button" class="mts-btn mts-ok" data-add-library="${MTS.escapeHtml(key)}">➕ Ajouter</button>
        </div>
      </div>
    `;
  }

  function renderLibrarySection(){
    return `
      <div class="mts-library-v24">
        <div class="mts-library-v24-grid">
          ${renderLibraryList("🏷️ Marques filaments", "filamentBrands", FILAMENT_BRANDS, "Nouvelle marque filament")}
          ${renderLibraryList("💧 Marques résines", "resinBrands", RESIN_BRANDS, "Nouvelle marque résine")}
          ${renderLibraryList("🧵 Matières filaments", "filamentMaterials", FILAMENT_MATERIALS, "Nouvelle matière filament")}
          ${renderLibraryList("💧 Matières résines", "resinMaterials", RESIN_MATERIALS, "Nouvelle matière résine")}
          ${renderLibraryList("🎨 Couleurs", "colors", MATERIAL_COLORS, "Nouvelle couleur")}
          ${renderLibraryList("🖨️ Marques imprimantes", "printerBrands", PRINTER_LIBRARY_BRANDS, "Nouvelle marque imprimante")}
          ${renderLibraryList("🧩 Modèles imprimantes", "printerModels", PRINTER_LIBRARY_MODELS, "Marque — Modèle")}
        </div>
      </div>
    `;
  }


  function openedSettingSections(){
    return Array.from(document.querySelectorAll(".mts-settings-section[open]"))
      .map(d => d.dataset.section || "")
      .filter(Boolean);
  }

  function keepSectionOpen(sectionName){
    const current = openedSettingSections();
    if(!current.includes(sectionName)) current.push(sectionName);
    return current;
  }

  function detailsOpenAttr(name, opened){
    return opened.includes(name) ? "open" : "";
  }



  function injectLibraryCss(){
    if(document.getElementById("mtsLibraryV24Css")) return;
    const style = document.createElement("style");
    style.id = "mtsLibraryV24Css";
    style.textContent = `
      .mts-library-v24{margin:0 20px 20px!important;display:grid!important;gap:14px!important}
      .mts-library-v24-grid{display:grid!important;grid-template-columns:repeat(auto-fit,minmax(300px,1fr))!important;gap:14px!important}
      .mts-library-v24-box{padding:14px!important;border-radius:18px!important;background:rgba(0,0,0,.16)!important;border:1px solid rgba(255,255,255,.08)!important}
      .mts-library-v24-box h5{margin:0 0 10px!important;color:#fff!important;font-size:15px!important}
      .mts-library-v24-tags{display:flex!important;flex-wrap:wrap!important;gap:7px!important;max-height:220px!important;overflow:auto!important;padding:10px!important;border-radius:14px!important;background:rgba(255,255,255,.035)!important;border:1px solid rgba(255,255,255,.06)!important}
      .mts-library-v24-tags span{border-radius:999px!important;padding:6px 9px!important;background:rgba(255,255,255,.07)!important;color:#ddd!important;font-size:11px!important;font-weight:900!important}
      .mts-library-v24-add{display:grid!important;grid-template-columns:1fr auto!important;gap:8px!important;align-items:center!important;margin-top:10px!important;padding-top:10px!important;border-top:1px solid rgba(255,255,255,.08)!important}
      .mts-library-v24-add input{width:100%!important;border:1px solid rgba(255,255,255,.14)!important;border-radius:14px!important;background:#101010!important;color:#fff!important;padding:11px 12px!important;font-family:'Fredoka',sans-serif!important;outline:none!important}
      @media(max-width:560px){.mts-library-v24-add{grid-template-columns:1fr!important}}
    `;
    document.head.appendChild(style);
  }


  function render(forceOpenSections){
    injectLibraryCss();
    const panel = document.getElementById("mtsPanelSettings");
    if(!panel) return;

    const opened = Array.isArray(forceOpenSections) ? forceOpenSections : openedSettingSections();
    const s = MTS.state.settings || mergeSettings(null);
    const selectedTheme = savedTheme();

    panel.innerHTML = `
      <div class="mts-card">
        <div class="mts-card-head">
          <div>
            <h3>⚙️ Paramètres MoRetro Studio</h3>
            <p>Réglages atelier utilisés par les devis, la production et les documents.</p>
          </div>
          <button type="button" class="mts-btn mts-ok" id="mtsSaveStudioSettings">Enregistrer</button>
        </div>

        <div class="mts-settings-v21">
          <details class="mts-settings-section" data-section="appearance" open>
            <summary>Apparence</summary>
            <div class="mts-theme-setting">
              <div>
                <strong>Theme du Studio</strong>
                <span>Choisis le rendu utilise sur cet appareil.</span>
              </div>
              <div class="mts-theme-segmented" role="group" aria-label="Theme du Studio">
                <button type="button" data-mts-theme-choice="light" aria-pressed="${selectedTheme === "light"}">Clair</button>
                <button type="button" data-mts-theme-choice="dark" aria-pressed="${selectedTheme === "dark"}">Sombre</button>
                <button type="button" data-mts-theme-choice="system" aria-pressed="${selectedTheme === "system"}">Systeme</button>
              </div>
            </div>
          </details>

          <details class="mts-settings-section" data-section="shop" ${detailsOpenAttr("shop", opened.length ? opened : ["shop"])}>
            <summary>🏪 Boutique</summary>
            <div class="mts-setting-grid">
              <label>Nom boutique<input id="mtsSettingShopName" value="${MTS.escapeHtml(s.shop.name || "")}"></label>
              <label>Email expéditeur<input id="mtsSettingSenderEmail" value="${MTS.escapeHtml(s.shop.senderEmail || "")}"></label>
            </div>
          </details>

          <details class="mts-settings-section" data-section="shopify" ${detailsOpenAttr("shopify", opened)}>
            <summary>🔗 Shopify</summary>
            <div class="mts-shopify-connect-box">
              <strong>Connexion Shopify / Railway</strong>
              <span>Si Shopify demande une reconnexion, utilise ce bouton.</span>
              <a class="mts-btn mts-ok" href="https://bubbly-vibrancy-production.up.railway.app/auth/start" target="_blank" rel="noopener">🔗 Reconnecter Shopify</a>
            </div>
          </details>

          <details class="mts-settings-section" data-section="printers" ${detailsOpenAttr("printers", opened)}>
            <summary>🖨️ Imprimantes</summary>
            <div class="mts-setting-title">
              <span></span>
              <button type="button" class="mts-btn mts-soft" id="mtsAddPrinter">Ajouter une imprimante</button>
            </div>
            <div class="mts-setting-list" id="mtsPrinterSettingsList">
              ${(s.printers || []).map(renderPrinterRow).join("")}
            </div>
          </details>

          <details class="mts-settings-section" data-section="library" ${detailsOpenAttr("library", opened)}>
            <summary>📚 Bibliothèque Atelier</summary>
            ${renderLibrarySection()}
          </details>

          <details class="mts-settings-section" data-section="materials" ${detailsOpenAttr("materials", opened)}>
            <summary>🧵 Filaments & résines / stock</summary>
            <div class="mts-setting-title">
              <span></span>
              <button type="button" class="mts-btn mts-soft" id="mtsAddFilament">Ajouter une bobine / résine</button>
            </div>
            <div class="mts-setting-list" id="mtsFilamentSettingsList">
              ${(s.filaments || []).map(renderFilamentRow).join("")}
            </div>
          </details>

          <details class="mts-settings-section" data-section="quote" ${detailsOpenAttr("quote", opened)}>
            <summary>💰 Réglages devis par défaut</summary>
            <div class="mts-setting-grid">
              <label>Matière par défaut<input id="mtsDefaultMaterial" value="${MTS.escapeHtml(s.quoteDefaults.material || "PLA")}"></label>
              <label>Prix matière €/kg<input type="number" step="0.01" min="0" id="mtsDefaultKgPrice" value="${MTS.escapeHtml(s.quoteDefaults.filamentKgPrice || 23)}"></label>
              <label>Électricité €/h<input type="number" step="0.01" min="0" id="mtsDefaultElectricity" value="${MTS.escapeHtml(s.quoteDefaults.electricityHourly || 0.25)}"></label>
              <label>Main d’œuvre €<input type="number" step="0.01" min="0" id="mtsDefaultLabor" value="${MTS.escapeHtml(s.quoteDefaults.laborFixed || 10)}"></label>
              <label>Marge %<input type="number" step="1" min="0" id="mtsDefaultMargin" value="${MTS.escapeHtml(s.quoteDefaults.marginPercent || 30)}"></label>
            </div>
          </details>
        </div>
      </div>
    `;

    bind();
  }

  function collect(){
    const current = MTS.state.settings || mergeSettings(null);

    return mergeSettings({
      ...current,
      appearance:{
        theme:savedTheme()
      },
      shop:{
        name:document.getElementById("mtsSettingShopName")?.value || "MoRetro 3D",
        senderEmail:document.getElementById("mtsSettingSenderEmail")?.value || "contact@moretro3d.fr"
      },
      quoteDefaults:{
        material:document.getElementById("mtsDefaultMaterial")?.value || "PLA",
        filamentKgPrice:Number(document.getElementById("mtsDefaultKgPrice")?.value || 23),
        electricityHourly:Number(document.getElementById("mtsDefaultElectricity")?.value || 0.25),
        laborFixed:Number(document.getElementById("mtsDefaultLabor")?.value || 10),
        marginPercent:Number(document.getElementById("mtsDefaultMargin")?.value || 30)
      },
      printers:(current.printers || []).map((p,i)=>({
        ...p,
        name:document.querySelector(`[data-setting-printer-index="${i}"][data-field="name"]`)?.value || p.name,
        active:document.querySelector(`[data-setting-printer-index="${i}"][data-field="active"]`)?.checked !== false
      })),
      filaments:(current.filaments || []).map((f,i)=>{
        const compatible = Array.from(document.querySelectorAll(`[data-setting-filament-index="${i}"][data-field="compatiblePrinters"]:checked`)).map(el=>el.value);
        return {
          ...f,
          name:document.querySelector(`[data-setting-filament-index="${i}"][data-field="name"]`)?.value || "",
          type:document.querySelector(`[data-setting-filament-index="${i}"][data-field="type"]`)?.value || f.type || "filament",
          brand:(document.querySelector(`[data-setting-filament-index="${i}"][data-field="brand"]`)?.value === "Autre..."
            ? (document.querySelector(`[data-setting-filament-index="${i}"][data-field="customBrand"]`)?.value || "Autre")
            : (document.querySelector(`[data-setting-filament-index="${i}"][data-field="brand"]`)?.value || "")),
          customBrand:document.querySelector(`[data-setting-filament-index="${i}"][data-field="customBrand"]`)?.value || "",
          material:(document.querySelector(`[data-setting-filament-index="${i}"][data-field="material"]`)?.value === "Autre..."
            ? (document.querySelector(`[data-setting-filament-index="${i}"][data-field="customMaterial"]`)?.value || "Autre")
            : (document.querySelector(`[data-setting-filament-index="${i}"][data-field="material"]`)?.value || "")),
          customMaterial:document.querySelector(`[data-setting-filament-index="${i}"][data-field="customMaterial"]`)?.value || "",
          color:(document.querySelector(`[data-setting-filament-index="${i}"][data-field="color"]`)?.value === "Autre..."
            ? (document.querySelector(`[data-setting-filament-index="${i}"][data-field="customColor"]`)?.value || "Autre")
            : (document.querySelector(`[data-setting-filament-index="${i}"][data-field="color"]`)?.value || "")),
          customColor:document.querySelector(`[data-setting-filament-index="${i}"][data-field="customColor"]`)?.value || "",
          newWeightG:Number(document.querySelector(`[data-setting-filament-index="${i}"][data-field="newWeightG"]`)?.value || f.newWeightG || 0),
          remainingG:Number(document.querySelector(`[data-setting-filament-index="${i}"][data-field="remainingG"]`)?.value || f.remainingG || 0),
          newVolumeL:Number(document.querySelector(`[data-setting-filament-index="${i}"][data-field="newVolumeL"]`)?.value || f.newVolumeL || 0),
          remainingVolumeL:Number(document.querySelector(`[data-setting-filament-index="${i}"][data-field="remainingVolumeL"]`)?.value || f.remainingVolumeL || 0),
          purchasePrice:Number(document.querySelector(`[data-setting-filament-index="${i}"][data-field="purchasePrice"]`)?.value || 0),
          kgPrice:Number(document.querySelector(`[data-setting-filament-index="${i}"][data-field="kgPrice"]`)?.value || f.kgPrice || 0),
          literPrice:Number(document.querySelector(`[data-setting-filament-index="${i}"][data-field="literPrice"]`)?.value || f.literPrice || 0),
          diameter:document.querySelector(`[data-setting-filament-index="${i}"][data-field="diameter"]`)?.value || f.diameter || "1.75",
          nozzleTemp:Number(document.querySelector(`[data-setting-filament-index="${i}"][data-field="nozzleTemp"]`)?.value || f.nozzleTemp || 0),
          bedTemp:Number(document.querySelector(`[data-setting-filament-index="${i}"][data-field="bedTemp"]`)?.value || f.bedTemp || 0),
          supplier:document.querySelector(`[data-setting-filament-index="${i}"][data-field="supplier"]`)?.value || "",
          reference:document.querySelector(`[data-setting-filament-index="${i}"][data-field="reference"]`)?.value || "",
          notes:document.querySelector(`[data-setting-filament-index="${i}"][data-field="notes"]`)?.value || "",
          compatiblePrinters:compatible,
          active:document.querySelector(`[data-setting-filament-index="${i}"][data-field="active"]`)?.checked !== false
        };
      })
    });
  }

  function bind(){
    document.querySelectorAll("[data-mts-theme-choice]").forEach(button=>{
      button.addEventListener("click", ()=>{
        const theme = normalizedTheme(button.dataset.mtsThemeChoice);
        applyTheme(theme);
        if(MTS.state.settings){
          MTS.state.settings.appearance = {...(MTS.state.settings.appearance || {}), theme};
        }
      });
    });

    document.querySelectorAll("[data-add-library]").forEach(btn=>{
      btn.addEventListener("click", async()=>{
        const key = btn.dataset.addLibrary;
        const input = document.querySelector(`[data-library-add-input="${CSS.escape(key)}"]`);
        const value = String(input?.value || "").trim();
        if(!value) return;

        const s = collect();
        s.library = s.library || {};
        s.library[key] = uniqueList([...(s.library[key] || []), value]);
        MTS.state.settings = s;
        await save(s);
        render(keepSectionOpen("library"));
      });
    });

    document.getElementById("mtsSaveStudioSettings")?.addEventListener("click", async()=>{
      try{
        await save(collect());
        alert("Paramètres enregistrés.");
      }catch(err){
        alert("Erreur paramètres : " + err.message);
      }
    });
document.getElementById("mtsAddPrinter")?.addEventListener("click", async()=>{
      const s = collect();
      s.printers.push({id:uid("printer"), name:"Nouvelle imprimante", active:true});
      MTS.state.settings = s;
      render(keepSectionOpen("printers"));
    });

    document.getElementById("mtsAddFilament")?.addEventListener("click", async()=>{
      const s = collect();
      s.filaments.push({id:uid("filament"), name:"Nouvelle bobine", brand:"", material:"PLA", color:"", newWeightG:1000, remainingG:1000, purchasePrice:s.quoteDefaults.filamentKgPrice || 23, kgPrice:s.quoteDefaults.filamentKgPrice || 23, diameter:"1.75", nozzleTemp:220, bedTemp:60, supplier:"", reference:"", notes:"", compatiblePrinters:[], active:true});
      MTS.state.settings = s;
      render(keepSectionOpen("materials"));
    });
document.querySelectorAll("[data-remove-printer]").forEach(btn=>{
      btn.addEventListener("click",()=>{
        const i = Number(btn.dataset.removePrinter);
        const s = collect();
        s.printers.splice(i,1);
        MTS.state.settings = s;
        render(keepSectionOpen("printers"));
      });
    });


    document.querySelectorAll("[data-validate-filament]").forEach(btn=>{
      btn.addEventListener("click", async()=>{
        try{
          const s = collect();
          MTS.state.settings = s;
          await save(s);
          render(keepSectionOpen("materials"));
          alert("Matériau enregistré.");
        }catch(err){
          alert("Erreur : " + err.message);
        }
      });
    });

    document.querySelectorAll("[data-remove-filament]").forEach(btn=>{
      btn.addEventListener("click",()=>{
        const i = Number(btn.dataset.removeFilament);
        const s = collect();
        s.filaments.splice(i,1);
        MTS.state.settings = s;
        render(keepSectionOpen("materials"));
      });
    });
  }

  async function start(){
    try{
      await load();
      render();
    }catch(err){
      console.warn("Paramètres Studio non chargés :", err.message);
      MTS.state.settings = mergeSettings(null);
      render();
    }
  }

  MTS.Settings = {
    DEFAULT_SETTINGS,
    load,
    save,
    render,
    start,
    activePrinters,
    activeFilaments,
    printerOptions,
    materialOptions,
    kgPriceFor,
    filamentOptions,
    filamentById,
    FILAMENT_BRANDS,
    RESIN_BRANDS,
    FILAMENT_MATERIALS,
    RESIN_MATERIALS,
    MATERIAL_COLORS
  };
})(window.MTS);
